




import { defineComponent } from '@vue/composition-api'
import TendersList from '@/views/Tender/views/TendersList.vue'

export default defineComponent({
  name: 'BuyingTenders',
  components: {
    TendersList,
  },
})
